export default {
  how_was_the_food: "Comment était la nourriture",
  how_was_the_service: "Comment était le service",
  how_was_the_hygiene: "Comment était l'hygiène",
  save: "Sauver",
  how_likely_would_you_recommend_teds_bistro_to_the_others_10_most_likely:
    "Quelle est la probabilité que vous recommandiez Ted's Bistro à d'autres ? (10 plus probable)",
};
